module.exports = __webpack_public_path__ + "img/uk-female.b34b5724.png";